import './styles.css';

const LoadingSpinner = () => {

    return (
        <div className='loadingSpinner'></div>
    );
};

export default LoadingSpinner;